// extracted by mini-css-extract-plugin
export default {"title":"Ezydkv7I","description":"t3CvYOGJ","code-input":"BrM6cqN8","button":"TTDPDJGs","legal":"_zv96c5y"};